// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDrrregmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDrrregmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDrrregmgrIconOutlined = function DrrpDrrregmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDrrregmgrIconOutlinedSvg
  }));
};

DrrpDrrregmgrIconOutlined.displayName = 'DrrpDrrregmgrIconOutlined';
export default React.forwardRef(DrrpDrrregmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDrrregmgrIconOutlined.js
// module id = 2559
// module chunks = 0